module.exports = __webpack_public_path__ + "media/images/emblems/Champoz-coat_of_arms-eb8aef7814cf008132050d591bac4a1c.svg";